import React, { useState, useEffect } from 'react';
import { useAxios } from '../utils/httpClient';
import { FilterTasks } from '../components/filterTasks';
import { useStore } from '../state/store';

export interface IFilterTasksContainerProps {
  name: string;
  setData: any;
  setAreAllTasksVisible?: any;
}

export const FilterTasksContainer: React.FC<IFilterTasksContainerProps> = ({ name, setData, setAreAllTasksVisible }) => {
  const httpClient = useAxios();
  const [creators, setCreators] = useState<Array<any>>([]);
  const [assignees, setAssignees] = useState<Array<any>>([]);
  const [checked, setChecked] = useState(false);
  const { setOwnerId, setAssigneeId, assigneeId, ownerId } = useStore(state => ({
    setOwnerId: state.setOwnerId,
    setAssigneeId: state.setAssigneeId,
    assigneeId: state.assigneeId,
    ownerId: state.ownerId
  }));

  useEffect(() => {
    httpClient.get('users/profile').then(res => {
      const users = res.data.items;
      setAssignees(users);
      setCreators(users);
    });
  }, []);

  const handleChangeCreator = (event: React.ChangeEvent<{ value: string }>) => {
    setOwnerId(event.target.value as any);
  };

  const handleChangeAssignee = (event: React.ChangeEvent<{ value: string }>) => {
    setAssigneeId(event.target.value as any);
  };

  // Note: No automatic search on filter changes - each route container (boardContainer,
  // backlogContainer, doneContainer) handles its own data fetching when ownerId/assigneeId change

  const handleSwitch = (e: React.MouseEvent) => {
    setChecked(!checked);
    if (setAreAllTasksVisible) {
      setAreAllTasksVisible(false);
    }
    setOwnerId('');
    setAssigneeId('');
    // No need to fetch here - each container's useEffect will automatically
    // refetch when ownerId/assigneeId change to empty strings
  };

  return (
    <FilterTasks
      creatorId={ownerId}
      assigneeId={assigneeId}
      creators={creators}
      assignees={assignees}
      handleChangeCreator={handleChangeCreator}
      handleChangeAssignee={handleChangeAssignee}
      handleSwitch={handleSwitch}
      checked={checked}
    />
  );
};
